import React from "react";

const relationshipData = {
  Peer: [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Direct Report, Peer, Reporting Manager", count: 1, type: "Competency" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Peer", count: 3, type: "Collaborative Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Friend: [
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Friend", count: 1, type: "Social Style - Friends" },
    { relationships: "Cousin, Daughter, Friend, Parent, Sibling, Son, Spouse", count: 1, type: "Overall Social Style" },
  ],
  Parent: [
    { relationships: "Parent", count: 1, type: "Social Style - Parents" },
  ],
  Teacher: [
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Mentor, Teacher", count: 1, type: "Self-Development Style" },
  ],
  Boss: [
    { relationships: "Boss, Reporting Manager", count: 1, type: "Execution Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Partner: [
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Business Partner", count: 1, type: "Social Style - Business Partner" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Mentor: [
    { relationships: "Mentor, Teacher", count: 1, type: "Brief Report" },
    { relationships: "Business Partner", count: 1, type: "Self-Development Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Spouse: [
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Business Partner", count: 1, type: "Self-Development Style" },
    { relationships: "Spouse", count: 1, type: "Social Style - Spouse" },
    { relationships: "Cousin, Daughter, Friend, Parent, Sibling, Son, Spouse", count: 1, type: "Overall Social Style" },
  ],
  "Business Partner": [
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Business Partner", count: 1, type: "Social Style - Business Partner" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Customer: [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Customer", count: 1, type: "Customer-Management Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  "Direct Report": [
    { relationships: "Direct Report", count: 1, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Direct Report" },
    { relationships: "Direct Report", count: 1, type: "Leadership Style" },
    { relationships: "Direct Report", count: 1, type: "Leadership Style" },
  ],
  Cousin: [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Customer", count: 1, type: "Customer-Management Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Son: [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Customer", count: 1, type: "Customer-Management Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Vendor: [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Customer", count: 1, type: "Customer-Management Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Mentee: [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Customer", count: 1, type: "Customer-Management Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Daughter: [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Customer", count: 1, type: "Customer-Management Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  "Reporting Manager": [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Customer", count: 1, type: "Customer-Management Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],
  Sibling: [
    { relationships: "Customer, Direct Report, Peer, Reporting Manager, Vendor", count: 3, type: "Value" },
    { relationships: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor", count: 1, type: "Brief Report" },
    { relationships: "Customer", count: 1, type: "Customer-Management Style" },
    { relationships: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor", count: 1, type: "360-Degree Feedback" },
  ],


};

const Relationshiptype = (relationType) => {
  localStorage.setItem(`${relationType} Relationship`, true);

  if (!relationshipData[relationType]) {
    return (
      <tr>
        <td colSpan="3">Invalid relationship type: {relationType}</td>
      </tr>
    );
  }

  return (
    <React.Fragment>
      {relationshipData[relationType].map(({ relationships, count, type }, index) => (
        <tr key={index}>
          <td>{relationships}</td>
          <td>{count}</td>
          <td>{type}</td>
        </tr>
      ))}
    </React.Fragment>
  );
};

export default Relationshiptype;



// WEBPACK FOOTER //
// ./src/new/Utils/RelationshipType.js